// Copyright (C) 2019 TANNER AG

import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core";
import * as PropTypes from "prop-types";
import classnames from "classnames";

const inputStyles = {
	input: {
		height: 45,
		border: "1px solid #cccccc;",
		// boxShadow: "inset 0 2px 0 0 #ececec;",
		borderRadius: "3px",
		padding: "12px 15px",
		fontFamily: "MANEurope, Arial, sans-serif",
		fontSize: "15px",
		lineHeight: "18px",
		fontStyle: "normal",
		fontWeight: 300,
		outline: "none",
		transition: "border-color 0.3s",
		"&:focus": {
			borderColor: "#303c49"
		}
	}
};

export const Input = withStyles(inputStyles)((props) => {
	const { classes, focus, ...others } = props;
	const ref = React.createRef();

	useEffect(() => {
		if (focus) {
			ref.current.focus();
		}
	}, [focus]);

	return (
		<input ref={ref} className={classes.input} {...others}/>
	);
});

const groupStyles = {
	group: {
		position: "relative",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "stretch",
		width: "100%",
		boxSizing: "border-box",
		"& > input": {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			position: "relative",
			flex: "1 1 auto",
			width: "1%"
		}
	},
	prepend: {
		display: "flex",
		marginRight: "-1px",
		boxSizing: "border-box",
		backgroundColor: "#303c49",
		borderRadius: "3px 0 0 3px",
		color: "#fff",
		justifyContent: "center",
		alignItems: "center",
		fontFamily: "MANEurope, Arial, sans-serif",
		fontSize: "15px",
		lineHeight: "18px",
		fontStyle: "normal",
		fontWeight: 300,
		padding: "0 15px"
	}
};

export const InputGroup = withStyles(groupStyles)((props) => {
	const { classes, className, prepend, children, ...others } = props;
	return (
		<div className={classnames(classes.group, className)} {...others}>
			<div className={classes.prepend}>{prepend}</div>
			{children}
		</div>
	);
});

InputGroup.propTypes = {
	prepend: PropTypes.string,
	children: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/tco/components/input.js